__turbopack_context__.v({
  "Cta": "HeroCta-module-scss-module__NvVXJa__Cta",
  "CtaContent": "HeroCta-module-scss-module__NvVXJa__CtaContent",
});
